/**
 * Takes in an object with properties for each page of results
 * Each page of results is an object with an items property
 * @param {*} objectArray
 * @returns
 */
export default function(pageObject) {
	const items = [];

	if (pageObject) {
		for (const prop in pageObject) {
			if (Object.hasOwnProperty.call(pageObject, prop)) {
				if (
					pageObject[prop] &&
					pageObject[prop].items &&
					pageObject[prop].items.length > 0
				)
					items.push(...pageObject[prop].items);
			}
		}
	}

	return items;
}
